import { ArrowRight, CheckCircle, XCircle } from "lucide-react";

export default function ComparisonView({ original, edited, changes = [] }) {
  if (!original && !edited) return null;

  const originalWords = original.split(/\s+/).length;
  const editedWords = edited.split(/\s+/).length;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4 text-sm text-slate-600">
        <span>Words: {originalWords}</span>
        <ArrowRight className="w-3.5 h-3.5" />
        <span>{editedWords}</span>
        <span className={`text-xs font-medium px-2 py-0.5 rounded ${
          editedWords <= originalWords
            ? "bg-green-100 text-green-700"
            : "bg-amber-100 text-amber-700"
        }`}>
          {editedWords > originalWords ? `+${editedWords - originalWords}` : editedWords < originalWords ? `-${originalWords - editedWords}` : "No change"}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Original */}
        <div className="border border-slate-200 rounded overflow-hidden">
          <div className="bg-slate-100 px-3 py-1.5 text-xs font-medium text-slate-600 border-b border-slate-200">
            Original
          </div>
          <div className="p-3 text-sm text-slate-700 max-h-[300px] overflow-y-auto whitespace-pre-wrap">
            {original}
          </div>
        </div>

        {/* Edited */}
        <div className="border border-slate-200 rounded overflow-hidden">
          <div className="bg-cyan-50 px-3 py-1.5 text-xs font-medium text-cyan-700 border-b border-cyan-200">
            Edited
          </div>
          <div className="p-3 text-sm text-slate-700 max-h-[300px] overflow-y-auto whitespace-pre-wrap">
            {edited}
          </div>
        </div>
      </div>

      {/* Changes list */}
      {changes.length > 0 && (
        <div className="border border-slate-200 rounded overflow-hidden">
          <div className="bg-slate-100 px-3 py-1.5 text-xs font-medium text-slate-600 border-b border-slate-200">
            Changes ({changes.length})
          </div>
          <div className="max-h-[200px] overflow-y-auto divide-y divide-slate-100">
            {changes.map((ch, i) => (
              <div key={i} className="px-3 py-2 flex items-start gap-2 text-sm">
                {ch.type === "insert" || ch.type === "replace" ? (
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 shrink-0" />
                ) : ch.type === "delete" ? (
                  <XCircle className="w-4 h-4 text-red-500 mt-0.5 shrink-0" />
                ) : null}
                <div>
                  {ch.original && (
                    <span className="line-through text-red-500 mr-2">{ch.original}</span>
                  )}
                  {ch.corrected && (
                    <span className="text-green-600 font-medium">{ch.corrected}</span>
                  )}
                  {ch.type === "insert" && <span className="text-green-600">{ch.content}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
